import React, { useRef } from "react";
import dynamic from "next/dynamic";
import DateTitle from "./DateTitle";

const DateDropDownContent = dynamic(() => import("./DateDropDownContent"), {
  ssr: false,
});

const DateDropdown = ({ setShowCalendar, showCalendar, setShowGuest }) => {
  const refDate = useRef(null);

  const handleShowCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  return (
    <div ref={refDate} className="w-full mb-2 lg:w-1/4 xsm:w-1/2 lg:mb-0">
      <DateTitle handleShowCalendar={handleShowCalendar} />
      {showCalendar && (
        <DateDropDownContent
          refDate={refDate}
          handleShowCalendar={handleShowCalendar}
          setShowCalendar={setShowCalendar}
          setShowGuest={setShowGuest}
        />
      )}
    </div>
  );
};

export default DateDropdown;
